import { useSelector } from "../../../store";
import {
  useGetEventVideoGroups,
  useGetEventVideoGroupsSets,
} from "../../streaming/videojsComponent/multiAngle/useVideoGroupsSet";

import type { EventVideo } from "@spwn/types/firebase/firestore";

/**
 * イベントに属するVideoGroupsSetsのメインビデオのリストを取得する
 * nameはVideoGroupsSetのnameに置き換えられる
 */
export const useGetMainVideoOfVideoGroupsSetList = (
  eventVideoList: EventVideo[]
): EventVideo[] => {
  const eventVideoMap = useSelector((state) => state.streaming.eventVideoMap);
  const { data: videoGroups = {} } = useGetEventVideoGroups(eventVideoMap);
  const { data: videoGroupsSets = {} } =
    useGetEventVideoGroupsSets(videoGroups);

  const videoGroupsSetsList = Object.values(videoGroupsSets)
    .sort((a, b) => a.priority - b.priority)
    .flatMap((set) => {
      const mainVideoId = set.mainVideoRef.id;

      const mainVideo = eventVideoList.find(
        (video) => video._id === mainVideoId
      );

      if (mainVideo === undefined) {
        return [];
      }

      return {
        ...mainVideo,
        name: set.name,
      };
    });

  return videoGroupsSetsList;
};
